import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import { useSEO, StructuredData, getBreadcrumbSchema } from '../utils/seoHelpers';

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  position: relative;
`;

const ContactPage: React.FC = () => {
  useSEO({
    title: 'Contact Market Nest | Digital Marketing Agency Greensboro, NC',
    description: 'Get in touch with Market Nest, Greensboro\'s premier digital marketing agency. Contact us for a free consultation and discover how we can grow your business.',
    keywords: 'contact Market Nest, digital marketing consultation, Greensboro marketing agency, get in touch, free consultation',
  });

  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: 'https://marketnest.org/' },
    { name: 'Contact', url: 'https://marketnest.org/contact' }
  ]);
  return (
    <PageContainer>
      <StructuredData data={breadcrumbSchema} />
      <Header />
      <ContactSection />
      <Footer />
    </PageContainer>
  );
};

export default ContactPage;
